module.exports = __webpack_public_path__ + "static/media/meeting2.ae7a5978.png";